export const buttonList = {
	// 管理员
	1: [
		"channelAdd",
		"channelDelete",
		"channelOpen",
		"channelClose",
		"channelAudit",
	],
	// 运维  只能编辑自己添加的
	9: [
		"channelAdd",
		"channelDelete",
		"channelOpen",
		"channelClose",
		"channelAudit",
		"channelEdit",
	],
	//信源  获取当前企业的频道列表  不能审核
	10: [
		"channelAdd",
		"channelDelete",
		"channelOpen",
		"channelClose",
		"channelEdit",
	],
};

export function isShow(list, button) {
	return list.indexOf(button) !== -1;
}
